import { FC } from 'react'

import styles from '../GiftTrackerHeader.styles.scss'

type GiftsPurchasedProps = {
  giftsPurchasedCount: number
  regItemsCount: number
}
const GiftsPurchased: FC<GiftsPurchasedProps> = ({
  giftsPurchasedCount,
  regItemsCount,
}) => (
  <div className={styles.GiftTrackerHeader__GiftsPurchased}>
    <div className={styles.GiftTrackerHeader__GiftsPurchasedCount}>
      {giftsPurchasedCount}/{regItemsCount}
    </div>
    <div className={styles.GiftTrackerHeader__GiftsPurchasedText}>
      gifts purchased
    </div>
  </div>
)

export default GiftsPurchased
